import * as AudioBackup from "../interfaces/IAudioBackup";
import * as AudioFormat from "../interfaces/IAudioFormat";


export class IndexeddbAudioBackupDummy implements AudioBackup.IAudioBackup {

    constructor () {
    }

    public async Initialize(): Promise<void> {
      return new Promise<void>((resolve) => {
        resolve();
     });
    }

    public IsInitializedSuccessfully(): boolean {
        return false; // as it is dummy indexeddb object
    }

    public Close(): void {}

    public FetchBackupState(): Promise<AudioBackup.BackupStates> {
        return new Promise<AudioBackup.BackupStates>(async (resolve) => {
            resolve(AudioBackup.BackupStates.None);
        });
    }

    public ClearBackup(): Promise<void> {
        return new Promise<void>((resolve) => {
            resolve();
        });
    }

    public BackupFormatProperties(_props: AudioFormat.IFormatProperties): Promise<void> {
        return new Promise<void>(async (resolve) => {
          resolve();
        });
    }

    public FetchFormatProperties(): Promise<AudioFormat.IFormatProperties> {
        return new Promise<AudioFormat.IFormatProperties>(async () => {});
    }

    public BackupChunk(_chunk: ArrayBuffer): Promise<void> {
        return new Promise<void>(async (resolve) => {
          resolve();
        });
    }

    public FetchChunks(): Promise<ArrayBuffer[]> {
        return new Promise<ArrayBuffer[]>(async () => {});
    }

};